import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { logout } from "auth/actions";

class Logout extends PureComponent {
  UNSAFE_componentWillMount() {
    this.props.logout();
  }

  render() {
    return <Redirect to="/login" />;
  }
}

export default connect(
  () => ({}),
  { logout }
)(Logout);
